import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { isValidShimmerKey } from '../constants/shimmer-keys';

@Injectable({ providedIn: 'root' })
export class ShimmerService {
  private loadingStates = new Map<string, BehaviorSubject<boolean>>();
  private usageCount = new Map<string, number>();

  loading$(key: string): Observable<boolean> {
    if (!isValidShimmerKey(key)) {
      console.warn(`Invalid shimmer key: ${key}`);
      return new BehaviorSubject<boolean>(false).asObservable();
    }

    if (!this.loadingStates.has(key)) {
      this.loadingStates.set(key, new BehaviorSubject<boolean>(false));
      this.usageCount.set(key, 0);
    }

    this.usageCount.set(key, (this.usageCount.get(key) || 0) + 1);
    return this.loadingStates.get(key)!.asObservable();
  }

  show(key: string) {
    if (!isValidShimmerKey(key)) {
      console.warn(`Invalid shimmer key: ${key}`);
      return;
    }

    const state = this.loadingStates.get(key);
    if (!state) {
      console.warn(`No shimmer state found for key: ${key}`);
      return;
    }
    state.next(true);
  }

  hide(key: string) {
    if (!isValidShimmerKey(key)) {
      console.warn(`Invalid shimmer key: ${key}`);
      return;
    }

    const state = this.loadingStates.get(key);
    if (!state) {
      console.warn(`No shimmer state found for key: ${key}`);
      return;
    }
    state.next(false);
  }

  removeState(key: string) {
    if (!isValidShimmerKey(key)) {
      return;
    }

    const count = (this.usageCount.get(key) || 0) - 1;
    if (count <= 0) {
      this.loadingStates.get(key)?.complete();
      this.loadingStates.delete(key);
      this.usageCount.delete(key);
    } else {
      this.usageCount.set(key, count);
    }
  }

  cleanup() {
    this.loadingStates.forEach((state) => state.complete());
    this.loadingStates.clear();
    this.usageCount.clear();
  }
}
